import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const DetailHeader = styled(Typography, {
  name: 'DetailHeader',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})(({ theme }) => {
  return {
    fontSize: '16px',
    marginBottom: theme.spacing(1),
  }
})
